import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'sticky bottom-0 left-0 z-60 flex w-full flex-col bg-white shadow-[0px_0px_12px_rgba(0,0,0,0.07)] lg:hidden',
    container: 'flex h-16 justify-between',
    item: 'text-icon-secondary flex-center w-1/5 cursor-pointer flex-col flex-wrap select-auto',
    label: 'flex-center mt-[2px] h-[17px] text-[12px] font-light',
    menu: 'fixed top-0 right-0 bottom-16 left-0 w-full overflow-auto bg-white',
    icon: 'relative',
    linkCounter: 'absolute -top-1 left-3'
  },
  variants: {
    color: {
      primary: 'text-black'
    }
  },
  defaultVariants: {
    color: 'primary'
  }
});
